import React from "react";
import AgendaPromoBanner from "../agenda/AgendaPromoBanner";
import { useSplashAds } from "../../hooks/useSplashAds";

export function MentorshipAdCardShimmer() {
  return <AgendaPromoBanner ads={[]} loading />;
}

function MentorshipAdCard() {
  const { ads: splashAds, isReady: areSplashAdsReady } = useSplashAds();

  return <AgendaPromoBanner ads={splashAds?.mentor_left || []} loading={!areSplashAdsReady} />;
}

export default React.memo(MentorshipAdCard);
